import { render } from "./IconLogo.vue?vue&type=template&id=5238ec28&scoped=true&ts=true"
import script from "./IconLogo.vue?vue&type=script&lang=ts"
export * from "./IconLogo.vue?vue&type=script&lang=ts"

import "./IconLogo.vue?vue&type=style&index=0&id=5238ec28&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5238ec28"]])

export default __exports__